import { getEnv } from 'configs/env';
import _, { defaultTo } from 'lodash';
import { Button, CreateAlert, Icon, NumberUtils, Table } from 'modules';
import moment from 'moment';
import React, { FC, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as XLSX from 'xlsx';

import { GeneralPopupCompnt } from '../../components/general-popup-compnt';
import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../components/table-filter-inputs/select';
import { getLocaleKey, translate } from '../../languages';
import { AdminService } from '../../services/admin';

const CopyToClipboardElement = CopyToClipboard as any;

export const PageClaimList: FC = (props: any) => {
  const StatusFilterOptions = [
    { label: 'PENDING', value: 'PENDING' },
    { label: 'APPROVED', value: 'APPROVED' },
    { label: 'REJECT', value: 'REJECT' },
  ];

  const BotStatusFilterOptions = [
    { label: 'PENDING', value: 'PENDING' },
    { label: 'SUCCESS', value: 'SUCCESS' },
    { label: 'FAILURE', value: 'FAILURE' },
  ];

  const [currentData, setCurrentData] = useState(null as any);
  const [valueCheckbox, setValueCheckbox] = useState<any>([]);
  const [isShowPopupApprove, setIsShowPopupApprove] = useState<boolean>(false);
  const [isShowPopupReject, setIsShowPopupReject] = useState<boolean>(false);
  const [messagePopup, setMessagePopup] = useState<any>();
  const [isShowTable, setIsShowTable] = useState<boolean>(true);
  const [indexExperienceGameId, setIndexExperienceGameId] = useState<any>();

  const startOfMonth = moment().subtract(1, 'months').startOf('month');
  const endOfDay = moment().endOf('day');
  const [params, setParams] = useState<any>();

  const handleOnClickConfirmApprove = () => {
    let payload;
    if (valueCheckbox[0]?.value === -1 && valueCheckbox[0]?.checked === true) {
      payload = {
        requestClaimIds: [0],
        approved: true,
      };
    }
    if (valueCheckbox[0]?.value !== -1) {
      const tempArr = valueCheckbox?.filter(
        (item: any) => item?.checked === true,
      );
      const tempRequestClaimIds = tempArr.map(
        (item: any) => item?.value?.requestClaimId,
      );
      payload = {
        requestClaimIds: tempRequestClaimIds,
        approved: true,
      };
    }
    setIsShowTable(false);
    AdminService.handleRequestClaim(payload)
      .then((res) => {
        setValueCheckbox([]);
        setIsShowTable(true);
        setIsShowPopupApprove(false);
        return CreateAlert({
          message: 'Approved successfully!',
          type: 'success',
        });
      })
      .catch((err) => {
        setValueCheckbox([]);
        setIsShowTable(true);
        setIsShowPopupApprove(false);
        return CreateAlert({ message: err.message, type: 'danger' });
      });
  };

  const handleOnClickConfirmReject = () => {
    let payload;
    if (valueCheckbox[0]?.value === -1 && valueCheckbox[0]?.checked === true) {
      payload = {
        requestClaimIds: [0],
        approved: false,
      };
    }
    if (valueCheckbox[0]?.value !== -1) {
      const tempArr = valueCheckbox?.filter(
        (item: any) => item?.checked === true,
      );
      const tempRequestClaimIds = tempArr.map(
        (item: any) => item?.value?.requestClaimId,
      );
      payload = {
        requestClaimIds: tempRequestClaimIds,
        approved: false,
      };
    }
    setIsShowTable(false);
    AdminService.handleRequestClaim(payload)
      .then((res) => {
        setValueCheckbox([]);
        setIsShowTable(true);
        setIsShowPopupReject(false);
        return CreateAlert({
          message: 'Reject successfully!',
          type: 'success',
        });
      })
      .catch((err) => {
        setValueCheckbox([]);
        setIsShowTable(true);
        setIsShowPopupReject(false);
        return CreateAlert({ message: err.message, type: 'danger' });
      });
  };

  const handleOnClickApproveButton = () => {
    if (valueCheckbox[0]?.value === -1 && valueCheckbox[0]?.checked === true) {
      setMessagePopup('Are you sure to approve all?');
    }
    if (valueCheckbox[0]?.value !== -1) {
      const numberSelectedRows = valueCheckbox?.filter(
        (item: any) => item?.checked === true,
      ).length;
      setMessagePopup(
        `Are you sure to approve ${numberSelectedRows} row${numberSelectedRows > 1 ? 's' : ''} selected?`,
      );
    }
    setIsShowPopupApprove(true);
  };

  const handleOnClickRejectButton = () => {
    if (valueCheckbox[0]?.value === -1 && valueCheckbox[0]?.checked === true) {
      setMessagePopup('Are you sure to reject all?');
    }
    if (valueCheckbox[0]?.value !== -1) {
      const numberSelectedRows = valueCheckbox?.filter(
        (item: any) => item?.checked === true,
      ).length;
      setMessagePopup(
        `Are you sure to reject ${numberSelectedRows} row${numberSelectedRows > 1 ? 's' : ''} selected?`,
      );
    }
    setIsShowPopupReject(true);
  };

  const handleOnClickActionOrders = (item: any) => {
    setIndexExperienceGameId(item?.experienceGameId);
  };

  return (
    <div className='page-claim-list'>
      <div className='button-container'>
        <Button
          disabled={!currentData}
          label='Export to Excel'
          buttonType='success'
          className='mb15'
          onClick={async () => {
            const response = await AdminService.getListRequestClaim({
              ...params,
              numberOfTransactionsPerPage: 10000,
              page: 1,
            });
            const data = [
              [
                'Email',
                'Time Request',
                'Game Trial Package',
                'USDT Refund',
                'Proof Photo 1',
                'Proof Photo 2',
                'Status',
                'Bot Status',
              ],
              ...response.data.map((item: any) => {
                const row: any[] = [];
                row.push(item.email);
                //row.push(moment.utc(item?.reqDate).format('YYYY/MM/DD HH:mm'));
                row.push(
                  new Date(item?.created).toLocaleString(getLocaleKey()),
                );
                row.push(
                  new Intl.NumberFormat('en').format(item?.packageValue),
                );
                row.push(
                  item?.packageValue *
                    ((new Date(item.created) >=
                    new Date('2022-12-05T10:00:00.000Z')
                      ? 7
                      : defaultTo(item?.percentLost, 3)) /
                      100),
                );
                row.push(item?.proofImage1);
                row.push(item?.proofImage2);
                row.push(
                  translate(`[ClaimScreen-StatusValue][${item?.status}]`),
                );
                row.push(
                  translate(`[ClaimScreen-BotStatusValue][${item?.botStatus}]`),
                );

                return row;
              }),
            ];

            const ws = XLSX.utils.aoa_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

            const now = new Date();
            XLSX.writeFile(
              wb,
              `Claim-Table-${now.toLocaleDateString().replace(/\//g, '-')} ${now
                .toLocaleTimeString()
                .replace(/:/g, '-')}.xlsx`,
              { type: 'binary' },
            );
          }}
        />
        <div className='right-container'>
          <div className='infor-container'>
            <div className='total-refund'>
              <div className='total-refund__icon'>
                <Icon.TotalRefundIcon />
              </div>
              <div className='total-refund__content'>
                {NumberUtils.toFormatNumber(currentData?.totalRefund, 8) ?? 0}
                <span className='sub-text'>&nbsp;TOTAL USDT REFUND</span>
              </div>
            </div>
          </div>
          <div className='button-group'>
            <Button
              disabled={valueCheckbox.length === 0}
              label='Approve'
              buttonType='success'
              className='approve-button'
              onClick={handleOnClickApproveButton}
            />
            <Button
              disabled={valueCheckbox.length === 0}
              label='Reject'
              buttonType='danger'
              className='reject-button'
              onClick={handleOnClickRejectButton}
            />
            {/* <p>
                            Total 3% MTG refund:{" "}
                            {NumberUtils.toFormatNumber(
                                currentData?.totalRefund,
                                8
                            )}
                        </p> */}
          </div>
        </div>
      </div>

      {isShowTable && (
        <Table
          hasOrderColumn
          hasCheckbox={true}
          onChangeCheckbox={(data) =>
            setValueCheckbox((preState: any) => {
              if (data.value === -1) {
                //data.value === -1 => check all or uncheck all
                if (data?.checked === true) return [data];
                if (data?.checked === false) return [];
              }
              const temp = preState?.filter(
                (item: any) => _.isEqual(item?.value, data?.value) === false,
              );
              if (data?.checked === true) return [...temp, data];
              if (data?.checked === false) return [...temp];
            })
          }
          valueCheckbox={valueCheckbox}
          className='overload'
          filters={[
            {
              name: 'Email',
              key: 'email',
              input: TableFilterInputText,
            },
            {
              name: translate('time'),
              key: 'created',
              input: (e) => (
                <TableFilterRangeTimeInput
                  {...e}
                  fromKey='fromDate'
                  toKey='toDate'
                />
              ),
              defaultValue: {
                //fromDate: moment().subtract(1,"months"),
                //toDate: moment(),
                fromDate: startOfMonth,
                toDate: endOfDay,
              },
            },
            {
              name: 'Status',
              key: 'status',
              input: (e) => (
                <TableFilterInputSelect
                  isClearable={true}
                  {...e}
                  options={StatusFilterOptions}
                  isSearchable={false}
                />
              ),
              defaultValue: 'PENDING',
            },
            // {
            //     name: "Bot Status",
            //     key: "botStatus",
            //     input: (e) => (
            //         <TableFilterInputSelect
            //             isClearable={false}
            //             {...e}
            //             options={BotStatusFilterOptions}
            //         />
            //     )
            // }
          ]}
          structure={[
            // {
            //     name: translate('Checkbox'),
            //     // key: "reqDate",
            //     render: (item:any) => <span><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" /></span>
            // },
            {
              name: 'Email',
              key: 'email',
              className: 'email',
              render: (item) => {
                return (
                  <div>
                    <CopyToClipboardElement
                      text={item.email}
                      onCopy={() => {
                        CreateAlert({
                          message: translate('Copied'),
                          type: 'success',
                        });
                      }}
                    >
                      <div className='value'>
                        <span className='email'>{item.email}</span>
                        <span className='icon'>
                          <Icon.Copy />
                        </span>
                      </div>
                    </CopyToClipboardElement>
                  </div>
                );
              },
            },
            {
              name: 'Time Request',
              key: 'created',
              render: (item) => {
                const date = new Date(item.created);
                return (
                  <span>
                    {date.toLocaleDateString(getLocaleKey())}
                    <br />
                    {date.toLocaleTimeString(getLocaleKey())}{' '}
                  </span>
                );
              },
            },
            {
              name: 'Game Trial Package',
              render: (item: any) => (
                <span
                  className={`experience-pack experience-pack--${item?.packageValue}`}
                >
                  {'$' + new Intl.NumberFormat('en').format(item?.packageValue)}
                </span>
              ),
            },
            {
              name: 'USDT Refund',
              render: (item: any) => {
                const created = new Date(item.created);
                const percentLost = defaultTo(item?.percentLost, 3);

                return `${NumberUtils.toFormatNumber(
                  item?.packageValue * (percentLost / 100),
                  +getEnv('NUMBER_DECIMAL_DISPLAY'),
                )} | ${percentLost}%`;
              },
            },
            {
              name: translate('Proof Photo 1'),
              key: 'proofImage1',
              render: (item: any) => (
                <a href={item?.proofImage1} target='_blank' rel='noreferrer'>
                  <img
                    className='proof-photo-1'
                    src={item?.proofImage1}
                    alt=''
                  />
                </a>
              ),
            },
            {
              name: translate('Proof Photo 2'),
              key: 'proofImage2',
              render: (item: any) => (
                <a href={item?.proofImage2} target='_blank' rel='noreferrer'>
                  <img
                    className='proof-photo-2'
                    src={item?.proofImage2}
                    alt=''
                  />
                </a>
              ),
            },
            {
              name: 'Status',
              key: 'status',
              render: (item: any) => (
                <span
                  className={`status status--${item?.status?.toLowerCase()}`}
                >
                  {_.startCase(_.toUpper(translate(item?.status)))}
                </span>
              ),
            },
            {
              name: 'Bot Status',
              key: 'botStatus',
              render: (item: any) => (
                <span
                  className={`bot-status bot-status--${item?.botStatus?.toLowerCase()}`}
                >
                  {_.startCase(_.toUpper(translate(item?.botStatus)))}
                </span>
              ),
            },
            {
              name: 'Action',
              render: (item: any) => (
                <div
                  className='action action--orders'
                  title='See first 8 orders'
                  onClick={() => handleOnClickActionOrders(item)}
                >
                  <Icon.ActionOrders />
                </div>
              ),
            },
          ]}
          // fetchData={async (params) =>
          //     AdminService.getListRequestClaim({
          //         ...params,
          //         numberOfTransactionsPerPage: params.limit,
          //         page: params.pageNumber,
          //         fromDate: '0',
          //         toDate: moment().toISOString()
          //     }).then((res) => {
          //         setCurrentData(res);
          //         return res;
          //     })
          // }
          fetchData={async (state) => {
            const params = { ...state };
            setParams(params);

            if (params['fromDate'])
              params['fromDate'] = new Date(params['fromDate']);
            if (params['toDate']) params['toDate'] = new Date(params['toDate']);

            return AdminService.getListRequestClaim({
              page: params.pageNumber,
              numberOfTransactionsPerPage: params.limit,
              ...params,
            }).then((res) => {
              setCurrentData(res);
              return res;
            });
          }}
        />
      )}
      {isShowPopupApprove ? (
        <GeneralPopupCompnt
          onClose={() => {
            setIsShowPopupApprove(false);
          }}
          onClickConfirm={() => handleOnClickConfirmApprove()}
          textButton='OK'
          titlePopup={'Notification!'}
          messagePopup={messagePopup}
        />
      ) : null}
      {isShowPopupReject ? (
        <GeneralPopupCompnt
          onClose={() => {
            setIsShowPopupReject(false);
          }}
          onClickConfirm={() => handleOnClickConfirmReject()}
          textButton='OK'
          titlePopup={'Notification!'}
          messagePopup={messagePopup}
        />
      ) : null}
      {indexExperienceGameId && (
        <OrdersPopupCompnt
          indexExperienceGameId={indexExperienceGameId}
          onClose={() => setIndexExperienceGameId(undefined)}
        />
      )}
    </div>
  );
};

const OrdersPopupCompnt: FC<any> = (props: any) => {
  return (
    <div className='orders-popup-compnt'>
      <div className='orders'>
        <div className='indicator-close' onClick={() => props?.onClose()}>
          <Icon.Close />
        </div>
        <div className='title'>First 8 Orders</div>
        <Table
          structure={[
            {
              name: 'DATE TIME',
              key: 'created',
              render: (item: any) =>
                moment(item?.created).format('YYYY/MM/DD HH:mm'),
            },
            {
              name: 'AMOUNT',
              render: (item: any) =>
                NumberUtils.toFormatNumber(
                  item?.amount,
                  +getEnv('NUMBER_DECIMAL_DISPLAY'),
                ) + '$',
            },
            {
              name: 'RESULT',
              // render: (item: any) => <span className={`status status--${item?.status?.toLowerCase()}`}>{new Intl.NumberFormat("en").format(item?.profit)}</span>,
              render: (item: any) => (
                <span
                  className={`status status--${item?.status?.toLowerCase()}`}
                >
                  {item.status == 'LOSE'
                    ? item.profit > 0
                      ? NumberUtils.toFormatNumber(
                          item.amount - item.profit,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )
                      : NumberUtils.toFormatNumber(
                          item.amount,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )
                    : item.status == 'WIN'
                      ? NumberUtils.toFormatNumber(
                          item.profit - item.amount,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )
                      : NumberUtils.toFormatNumber(
                          item.profit,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )}
                  $
                </span>
              ),
            },
          ]}
          fetchData={async (state) =>
            AdminService.getOrdersForClaimRequest(props?.indexExperienceGameId)
          }
        />
      </div>
    </div>
  );
};
